import { render, staticRenderFns } from "./AddArticles.vue?vue&type=template&id=551bc3f4&scoped=true&lang=true&"
import script from "./AddArticles.vue?vue&type=script&lang=js&"
export * from "./AddArticles.vue?vue&type=script&lang=js&"
import style0 from "./AddArticles.vue?vue&type=style&index=0&id=551bc3f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551bc3f4",
  null
  
)

export default component.exports